import React, { useCallback } from 'react';
import { useModalStore, useAuthStore } from '@/store';
import useResponsiveness from '@/hooks/useResponsiveness';
import { useTranslation } from '@/hooks/useTranslation';
import { useRouter } from 'expo-router';
import NavigationBarButtonContainer from '@/components/Navigation/NavigationBarButtonContainer';
import NavigationBarButton from '@/components/Navigation/NavigationBarButton';
import { trackEvent } from '@/constants/utils/analytics';

export const ExploreRouteNavigationHeaderRight = React.memo(() => {
  const { t } = useTranslation();
  const { isXS } = useResponsiveness();
  const { openModal } = useModalStore(state => state.actions);
  const token = useAuthStore(state => state.token);
  const router = useRouter();

  const handleCategoriesClick = useCallback((e) => {
    e?.preventDefault?.();
    e?.stopPropagation?.();
    trackEvent('explore', 'explore_header_categories_click');
    router.push('/explore/categories');
  }, [router]);

  const handleSignupClick = useCallback((e) => {
    e?.preventDefault?.();
    e?.stopPropagation?.();
    trackEvent('explore', 'explore_header_signup_click');
    openModal('SignupModal');
  }, [openModal]);

  const handleLoginClick = useCallback((e) => {
    e?.preventDefault?.();
    e?.stopPropagation?.();
    trackEvent('explore', 'explore_header_login_click');
    openModal('LoginModal');
  }, [openModal]);

  const categoriesLabel = t('explore.browseCategories') || 'Categories';

  return (
    <NavigationBarButtonContainer rightPadding>
      <NavigationBarButton
        label={isXS ? undefined : categoriesLabel}
        icon={isXS ? 'layer-group' : undefined}
        tooltip={isXS ? categoriesLabel : undefined}
        appendIcon="angle-right"
        appendIconSize={10}
        variant="transparent"
        onPress={handleCategoriesClick}
      />
      {!token ? (
        <>
          <NavigationBarButton
            label={isXS ? undefined : 'Log in'}
            icon={isXS ? 'right-to-bracket' : undefined}
            tooltip={isXS ? 'Log in' : undefined}
            variant="transparent"
            onPress={handleLoginClick}
          />
          <NavigationBarButton
            label="Sign up"
            icon="user-plus"
            variant="primary"
            onPress={handleSignupClick}
          />
        </>
      ) : null}
    </NavigationBarButtonContainer>
  );
});

ExploreRouteNavigationHeaderRight.displayName = 'ExploreRouteNavigationHeaderRight';

const ExploreRouteNavigationOptions = {
  title: 'Explore',
  headerTitle: 'Explore',
  headerBackVisible: false,
  headerRight: () => <ExploreRouteNavigationHeaderRight />,
};

export default ExploreRouteNavigationOptions;
